// Filters out empty or placeholder contact values (UNKNOWN, N/A, <UNKNOWN>, etc.)
// so they never render in the resume header.
const PLACEHOLDERS = new Set([
  '', 'unknown', 'n/a', 'na', 'none', 'null', 'not provided',
  'not available', 'notavailable', 'tbd', '-',
]);

export function isRealValue(v) {
  if (!v || typeof v !== 'string') return false;
  const cleaned = v.trim().toLowerCase().replace(/[<>[\]]/g, '');
  return cleaned.length > 0 && !PLACEHOLDERS.has(cleaned);
}

export function realValues(arr) {
  return arr.filter(isRealValue);
}

// Skills can be short keywords ("Python") or grouped competencies
// ("Microsoft Security: Sentinel, Defender, …"). The latter read far better as
// full-width labelled rows than as pills or a rigid grid.
export function isCategorizedSkills(skills) {
  if (!Array.isArray(skills) || !skills.length) return false;
  const longish = skills.filter(s => typeof s === 'string' && s.includes(':') && s.length > 40);
  return longish.length >= Math.max(2, Math.ceil(skills.length / 2));
}

export function splitSkill(s) {
  const i = typeof s === 'string' ? s.indexOf(':') : -1;
  if (i > 0 && s.length > 40) return { label: s.slice(0, i).trim(), rest: s.slice(i + 1).trim() };
  return { label: null, rest: s };
}

// Certifications always arrive as an array from the AI (possibly empty, or with
// blank/placeholder fields). Keep only entries with a real name — same
// placeholder rules as the backend's _valid_certs so preview matches download.
export function validCerts(resume) {
  const certs = resume && Array.isArray(resume.certifications) ? resume.certifications : [];
  return certs.filter(c => c && isRealValue(c.name));
}

// "Issuer  |  Date" with blanks dropped, so a missing field never leaves a
// dangling separator.
export function certMeta(cert, sep = '  |  ') {
  return realValues([cert.issuer, cert.date]).join(sep);
}
